import * as Yup from 'yup';

export default Yup.object().shape({
  name: Yup.string().required('Name is required').max(500),
  clientNo: Yup.string().required('Client No. is required').max(100),
  contactName: Yup.string().nullable().max(150),
  contactPhone: Yup.string().nullable().max(20),
  contactEmail: Yup.string().nullable().email('Please enter a valid email address').max(100),
  address1: Yup.string().nullable().max(150),
  address2: Yup.string().nullable().max(150),
  city: Yup.string().nullable().max(150),
  state: Yup.string().nullable().max(50),
  country: Yup.string().nullable().max(50),
  zipCode: Yup.string().nullable().max(10),
  isActive: Yup.bool().nullable(),
});